import { Path } from "react-native-svg";
import CustomIcon, { CustomIconProps } from "./CustomIcon";

const ChevronDown: React.FC<CustomIconProps> = (props) => (
  <CustomIcon {...props}>
    <Path clipRule="evenodd" d="M3.22166 7.31964C3.22166 6.90727 3.35912 6.63235 3.63403 6.35744C4.18386 5.80761 5.0086 5.80761 5.55843 6.35744L9.95705 10.7561L14.2182 6.35744C14.7681 5.80761 15.5928 5.80761 16.1426 6.35744C16.6924 6.90727 16.6924 7.73201 16.1426 8.28184L10.7818 13.6427C10.5069 13.9176 10.232 14.055 9.8196 14.055C9.40723 14.055 9.13231 13.9176 8.8574 13.6427L3.63403 8.28184C3.35912 8.00692 3.22166 7.73201 3.22166 7.31964Z" fillRule="evenodd" /> 
  </CustomIcon>
);

export default ChevronDown;